// Canonical Norms upload-template columns (used by the sample template
// download in NormUploadModal).
//
// The backend parser (prx_project_management_service
// src/utils/helper.util.ts parseNormsFileToJson) locates the header row by
// the 'Item Code' cell and maps columns BY HEADER TEXT, forward-filling
// blank Item Code / Item Description cells (merged-cell style groups).
// The master EXPORT is built server-side in the same format
// (prx_project_management_service src/norms/helpers/norms-export.helper.ts)
// — any header change must stay in sync across all three places.

export const NORMS_TEMPLATE_HEADERS = [
  "Item Code",
  "Item Description",
  "Material Description",
  "Material Purchase Unit",
  "PUC Factor",
  "Consumption Norm/Unit",
  "Material Wastage (%)",
  "Material Unit Price",
];

export const NORMS_TEMPLATE_COL_WIDTHS = [
  { wch: 12 },
  { wch: 38 },
  { wch: 32 },
  { wch: 20 },
  { wch: 10 },
  { wch: 20 },
  { wch: 20 },
  { wch: 18 },
];
